import {RecordForm} from '../forms/RecordForm';


import {usePrice} from '../hooks/usePrice.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {useParams} from "react-router-dom";


export const AddPage = () => {

    const {id: productId} = useParams()

    if (!productId) {
        throw new Error('productId is required');
    }

    const {
        record,
        createRecord,
    } = usePrice(productId);

    return (
        <FormPageLayout
            title='Add Price'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record || {} as any} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
